<template>
  <div class="col  mt-3">
    <div class="el-button-group mb-3">
      <router-link
        tag="el-button"
        class="el-button--medium"
        active-class="el-button--primary"
        to="/teklif/fatura"
        type="default"
        >{{ $t("fatura.fatura") }}
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/Module/teklif/_route.vue